/* eslint-disable react/prop-types */
import React, { createContext, useState, useCallback, useMemo } from 'react';

const StepperContext = createContext();

export const StepperProvider = ({ children }) => {
  const [step, setStep] = useState(1);

  // Evita recrear la función en cada render
  const handleChangeStep = useCallback((stepNumber) => {
    setStep(stepNumber);
  }, []);

  // Memoriza el value del provider para que no cambie su referencia
  const value = useMemo(() => ({
    step,
    handleChangeStep,
  }), [step, handleChangeStep]);

  return <StepperContext.Provider value={value}>{children}</StepperContext.Provider>;
};

export default StepperContext;